module.exports = __webpack_public_path__ + "media/fastweb_volunteers/DoSomething_Grandparents-74f993ca.gif";